/* global paypal, gf_check_field_rule, gformIsRecaptchaPending, gformCalculateTotalPrice, gforms_ppcp_frontend_strings */

window.GFPPCP = null;

( function ( $ ) {

	window.GFPPCP = function ( args ) {
		for ( let prop in args ) {
			if ( args.hasOwnProperty( prop ) ) {
				this[ prop ] = args[ prop ];
			}
		}

		this.form          = null;
		this.countryCode   = '';
		this.paymentMethod = '';
		this.activeFeed    = null;
		this.feedActivated = false;
		this.strings = gforms_ppcp_frontend_strings;

		let self = this;

		self.init = function() {
			self.form = '#gform_' + self.formId;
			self.GFCCField = '#field_' + self.formId + '_' + self.ccFieldId;
			self.paypalButtons = $( '#gform_ppcp_smart_payment_buttons' );
			self.orderIdField = $( '#gf_ppcp_order_id' );
			self.subscriptionIdField = $( '#gf_' + self.formId + '_ppcp_subscription_id' );
			self.totalName = 'gform_ppcp_amount_' + self.formId;
			self.btnArgs = null;

			self.bindFrontendFeedsEvaluated();
			self.applyPriceClass();
			self.bindFormTotalUpdate();

			$( self.form ).on(
				'submit',
				function () {
					if ( self.isGoPrevPage() ) {
						self.removeIdFields();
					}
				}
			);


			gformCalculateTotalPrice( self.formId );
		};

		self.bindFrontendFeedsEvaluated = function () {
			gform.addAction('gform_frontend_feeds_evaluated', function ( feeds, formId ) {
				if ( formId !== self.formId ) {
					return;
				}

				self.feedActivated = false;

				const firstActivePPCPFeed = self.getFirstActivePPCPFeed( feeds );

				if ( false === firstActivePPCPFeed ) {
					return;
				}

				self.feedActivated = true;
				self.loadActiveFeedSettings( firstActivePPCPFeed );
				self.prepareSmartBtnArgs( self.activeFeed );
				self.setPayPalScriptSrc( self.activeFeed );
				self.renderPaymentMethod();
			});
		};

		/**
		 * Filters form feeds after conditional logic has been evaluated to get the first PPCP active feed.
		 *
		 * If there are more than one active feed for any payment add-on, only the first one is honored.
		 *
		 * @since 2.0
		 *
		 * @param {array} EvaluatedFormFeeds All form feeds.
		 *
		 * @return {boolean|object} The first active feed object or false if no active feeds exist.
		 */
		self.getFirstActivePPCPFeed = function( EvaluatedFormFeeds ) {

			const activePPCPFeeds = EvaluatedFormFeeds.filter( function( feed ) {
				return feed.addonSlug === 'gravityformsppcp' && feed.isActivated;
			});

			if ( activePPCPFeeds.length ) {
				return activePPCPFeeds.shift();
			}

			return false;
		}

		/**
		 * Loads the settings of the active feed.
		 *
		 * @since 2.0
		 *
		 * @param {object} FirstActivePPCPFeed The first Active PPCP feed found after conditional logic evaluation.
		 *
		 * @return {boolean|Object} Feed settings object or false if failed to load the settings.
		 */
		self.loadActiveFeedSettings = function( FirstActivePPCPFeed ) {
			// Reset the active feed in case it was set.
			self.activeFeed = null;

			for ( let i = 0; i < Object.keys( self.feeds ).length; i++ ) {
				if ( self.feeds[ i ].feedId === FirstActivePPCPFeed.feedId ) {
					self.activeFeed = self.feeds[ i ];
					return self.activeFeed;
				}
			}

			return false;
		};

		/**
		 * Builds the smart buttons arguments array according to feed type.
		 *
		 * @since 2.0
		 *
		 * @param {Array} activeFeed The current active feed being processed.
		 */
		self.prepareSmartBtnArgs = function( activeFeed ) {

			self.btnArgs = {
				style: {
					layout: self.smartPaymentButtons.buttonsLayout,
					color: self.smartPaymentButtons.buttonsColor,
					shape: self.smartPaymentButtons.buttonsShape,
				},
			};

			if ( activeFeed.intent === 'authorize' || activeFeed.intent === 'capture' ) {
				self.btnArgs.onApprove = self.onOrderApprove;
				self.btnArgs.createOrder = self.createOrder;
			} else if ( activeFeed.intent === 'subscription' ) {
				self.btnArgs.createSubscription = self.createSubscription;
				self.btnArgs.onApprove = self.onSubscriptionApprove;
				self.btnArgs.onError = self.onSubscriptionError;
				self.btnArgs.onCancel = self.onSubscriptionCancel;
				self.btnArgs.fundingSource = paypal.FUNDING.PAYPAL;
			}

		};

		/**
		 * Sets the PayPal script src intent attribute according to feed type.
		 *
		 * @since 2.0
		 *
		 * @param {Array} activeFeed The current active feed being processed.
		 */
		self.setPayPalScriptSrc = function( activeFeed ) {
			const scriptTag = $( 'script[data-identifier="gform_ppcp_js_sdk"]' );
			let src = scriptTag.attr( 'src' );
			// Reset intent.
			src = src.replace( '&intent=authorize', '' ).replace( '&intent=subscription', '' ).replace( '&vault=true', '' ).replace( '&intent=capture', '' );
			if ( activeFeed.intent === 'authorize' || activeFeed.intent === 'capture' ) {
				src += '&intent=' + activeFeed.intent;
			} else if ( activeFeed.intent === 'subscription' ) {
				src += '&vault=true&intent=subscription';
			}
			scriptTag.attr( 'src', src );
		};

		/**
		 * Applied the class name "gform_ppcp_field_price" to fields that
		 * affect the conditional logic.
		 */
		self.applyPriceClass = function () {
			if ( window['gf_form_conditional_logic'] === undefined || window['gf_form_conditional_logic'][ self.formId ] === undefined ) {
				return;
			}

			const fieldsKey   = Object.keys( window['gf_form_conditional_logic'][ self.formId ].fields );
			const fieldsValue = Object.values( window['gf_form_conditional_logic'][ self.formId ].fields );
			let fields        = [];

			for ( let i = 0; i < fieldsValue.length; i++ ) {
				if ( fieldsValue[ i ].length ) {
					fields.push( fieldsKey[ i ] );
				}
			}

			for ( let i = 0; i < fields.length; i++ ) {
				$( '#field_' + self.formId + '_' + fields[ i ] ).not( '.gfield_price' ).addClass( 'gform_ppcp_field_price' );
			}
		}

		self.bindFormTotalUpdate = function () {
			// Set priority to 51 so it will be triggered after the coupons add-on
			gform.addFilter(
				'gform_product_total',
				function ( total, formId ) {
					// When the page is just initiated, the total and formId are both '0'.
					if ( formId === '0' ) {
						return total;
					}

					if (window[ self.totalName ] !== undefined && window[ self.totalName ] !== total) {
						self.removeIdFields();
					}

					window[ self.totalName ] = total;

					// PayPal buttons need to be hidden if the total is 0.
					self.renderPayPalField();

					return total;
				},
				51
			);
		};

		self.bindSpinnerTargetElem = function () {
			gform.addFilter(
				'gform_spinner_target_elem',
				function ( elem ) {
					return $( '#gform_wrapper_' + self.formId + ' .gform_next_button, #gform_send_resume_link_button_' + self.formId + ', #gform_ppcp_smart_payment_buttons' );
				}
			);
		};

		self.getDiscountTotal = function () {
			let discountTotal = 0, discount;
			if ( window[ 'gf_coupons' + self.formId ] !== undefined && self.activeFeed.paymentAmount === 'form_total' ) {
				const size = Object.values( window[ 'gf_coupons' + self.formId ] ).length;
				// Add flat discount first.
				for ( let i = 0; i < size; i++ ) {
					discount = Object.values( window[ 'gf_coupons' + self.formId ] )[ i ];
					if ( discount.type === 'flat' ) {
						// Discount amount is the same as coupon amount because it is a flat coupon.
						discountTotal += gform.applyFilters( 'gform_coupons_discount_amount', discount.amount, discount.type, discount.amount, self.itemTotal, discountTotal );
					}
				}
				// Calculate percentage discount AFTER discounted the flat amount.
				for ( let i = 0; i < size; i++ ) {
					discount = Object.values( window[ 'gf_coupons' + self.formId ] )[ i ];
					if ( discount.type === 'percentage' ) {
						const couponAmount  = discount.amount;
						const discountValue = gformRoundPrice( ( self.itemTotal + self.shipping - discountTotal ) * couponAmount / 100 );
						discountTotal      += gform.applyFilters(
							'gform_coupons_discount_amount',
							discountValue,
							discount.type,
							couponAmount,
							self.itemTotal,
							discountTotal
						);
					}
				}
			}

			/**
			 * gform_discount_total
			 *
			 * Modify the discount total value.
			 *
			 * @since 2.1
			 *
			 * @param {float}  discountTotal The calculated positive discount total value.
			 * @param {int}    formId        The current form id.
			 * @param {float}  Total         The form total value.
			 *
			 * @return {float} The modified discount total.
			 */
			return gformRoundPrice( Math.abs( gform.applyFilters( 'gform_ppcp_discount_total', gformRoundPrice( discountTotal ), self.formId, gformRoundPrice( window[ self.totalName ] ) ) ) );
		};

		self.getOrderData = function () {
			self.items     = [];
			self.itemTotal = self.shipping = 0;

			$.ajax(
				{
					async: false,
					url: gforms_ppcp_frontend_strings.ajaxurl,
					dataType: 'json',
					method: 'POST',
					data: {
						action: "gfppcp_get_order_data",
						nonce: gforms_ppcp_frontend_strings.create_order_nonce,
						form_id: self.formId,
						feed_id: self.activeFeed.feedId,
						data: $( self.form ).serialize(),
					},
					success: function ( response ) {
						if ( response.success ) {
							self.items     = response.data.items;
							self.itemTotal = response.data.itemTotal;
							// Set the field total as the submission total.
							if ( self.activeFeed.paymentAmount !== 'form_total' ) {
								window[ self.totalName ] = self.itemTotal;
							}
							self.shipping = response.data.shipping;
						}
					}
				}
			);
		};

		self.getMergeTagValue = function ( field ) {
			if ( field === '' ) {
				return '';
			} else {
				return GFMergeTag.replaceMergeTags( self.formId, '{:' + field + '}' );
			}
		};

		self.updateOrderDetails = function () {
			const activeFeed = self.activeFeed;

			let payer = {
				name: {
					given_name: self.getMergeTagValue( activeFeed.first_name ),
					surname: self.getMergeTagValue( activeFeed.last_name )
				}
			};

			if ( self.countryCode !== '' ) {
				payer.address = {
					address_line_1: self.getMergeTagValue( activeFeed.address_line1 ),
					address_line_2: self.getMergeTagValue( activeFeed.address_line2 ),
					admin_area_2: self.getMergeTagValue( activeFeed.address_city ),
					admin_area_1: self.getMergeTagValue( activeFeed.address_state ),
					postal_code: self.getMergeTagValue( activeFeed.address_zip ),
					country_code: self.countryCode
				};
			}

			if ( self.getMergeTagValue( activeFeed.email ) !== '' ) {
				payer.email_address = self.getMergeTagValue( activeFeed.email );
			}
			const shipping      = ( activeFeed.no_shipping === '1' ) ? 'NO_SHIPPING' : 'GET_FROM_FILE';
			let shippingDetails = ( activeFeed.no_shipping === '0' ) ? {
				name: {
					full_name: self.getMergeTagValue( activeFeed.first_name ) + ' ' + self.getMergeTagValue( activeFeed.last_name )
				}
			} : {};

			if ( shipping !== 'NO_SHIPPING' && self.countryCode !== '' ) {
				shippingDetails.address = payer.address;
			}

			let breakdown = {
				item_total: {
					value: gformRoundPrice( self.itemTotal ).toString(),
					currency_code: self.currency,
				},
				shipping: {
					value: gformRoundPrice( self.shipping ).toString(),
					currency_code: self.currency,
				}
			};

			// Get discount.
			const discountTotal = self.getDiscountTotal();
			if ( discountTotal > 0 ) {
				breakdown.discount = {
					value: discountTotal.toString(),
					currency_code: self.currency,
				};
			}

			const purchase_units = [{
				amount: {
					value: gformRoundPrice( window[ self.totalName ] ).toString(),
					currency_code: self.currency,
					breakdown: breakdown
				},
				description: activeFeed.feedName,
				items: self.items
			}];

			if ( shipping !== 'NO_SHIPPING' ) {
				purchase_units[0].shipping = shippingDetails;
			}

			return {
				payer: payer,
				purchase_units: purchase_units,
				application_context: {
					shipping_preference: shipping
				}
			};
		};

		self.createOrder = async function () {
			let orderID = '';

			if ( self.orderIdField.length ) {
				return self.orderIdField.val();
			}

			self.countryCode = self.getMergeTagValue( self.activeFeed.address_country );
			if ( self.countryCode !== '' ) {
				// It could just be a country value, but not code yet.
				await self.getCountryCode( self.countryCode );
			}

			await self.getOrderData();

			await fetch(
				gforms_ppcp_frontend_strings.ajaxurl + '?action=gfppcp_create_order',
				{
					method: 'POST',
					headers: {
						'content-type': 'application/json'
					},
					body: JSON.stringify(
						{
							nonce: gforms_ppcp_frontend_strings.create_order_nonce,
							data: self.updateOrderDetails(),
							form_id: self.formId,
							feed_id: self.activeFeed.feedId
						}
					)
				}
			).then(
				function ( res ) {
					return res.json();
				}
			).then(
				function ( response ) {
					if ( response.success ) {
						orderID = response.data.orderID;
						$( self.form ).append( $( '<input type="hidden" id="gf_ppcp_order_id" name="ppcp_order_id" />' ).val( orderID ) );
						self.resetCardErrors();
					} else {
						self.displayCardError( response.data.message );
						self.resetPayPalStatus();
						return false;
					}
				}
			);

			return orderID;
		}

		self.onOrderApprove = function( data, actions ) {
			gformAddSpinner( self.formId );

			$( self.form ).submit();
		}

		/**
		 * Determine whether the PayPal Smart Checkout buttons can be displayed.
		 *
		 * @return {boolean} Result.
		 */
		self.canShowSmartButtons = function() {
			var canShowSubmitButton  = gf_check_field_rule( self.formId, 0 ) === 'show';
			var canShowPayPalButtons = canShowSubmitButton && gf_check_field_rule( self.formId, self.ccFieldId ) === 'show';

			return (
				canShowPayPalButtons &&
				self.feedActivated &&
				window[ self.totalName ] &&
				self.paymentMethod === 'PayPal Checkout' &&
				self.isLastPage()
			);
		};

		/**
		 * Determine whether the Custom Card Field inputs and submit button can be displayed.
		 *
		 * @return {boolean} Result.
		 */
		self.canShowCustomCardFields = function() {
			return (
				self.paymentMethod === 'Credit Card' &&
				paypal.HostedFields.isEligible() &&
				window[ self.totalName ] > 0 &&
				self.activeFeed.intent !== 'subscription'
			);
		};

		/**
		 * Render the PayPal field, depending on the chosen payment method.
		 */
		self.renderPayPalField = function() {
			if ( self.paymentMethod === 'Credit Card' ) {
				self.renderCustomCardFields();
			} else {
				self.renderPayPalButtons();
			}
		};

		/**
		 * Render the PayPal Smart Buttons.
		 */
		self.renderPayPalButtons = function() {
			// Clear the rendered fields.
			$( '.ginput_container_custom_card_fields' ).hide();

			if ( ! self.canShowSmartButtons() ) {
				self.togglePaypalButtons( 'none' );
				self.toggleSubmitButton( 'visible' );
				return;
			}

			// Hide the submit button.
			self.toggleSubmitButton( 'hidden' );
			// Show the Smart Buttons.
			self.togglePaypalButtons( 'inline-block' );

			if ( !paypal.Buttons.instances.length ) {
				self.bindSpinnerTargetElem();
				paypal.Buttons( self.btnArgs ).render( '#gform_ppcp_smart_payment_buttons' );
			}
		};

		/**
		 * Creates a PayPal subscription.
		 *
		 * @since 2.0
		 *
		 * @param {Object} data
		 * @param {Object} actions
		 */
		self.createSubscription = async function( data, actions ) {
			gformAddSpinner( self.formId );

			// If we already have a subscription id, submit form.
			if ( self.subscriptionIdField.length ) {
				$( self.form ).submit();
			}

			// Get plan ID  or create a new one if no plan matches the current subscription properties.
			let subscriptionRequest = '';
			await fetch(
				gforms_ppcp_frontend_strings.ajaxurl + '?action=gfppcp_create_subscription',
				{
					method: 'POST',
					headers: {
						'content-type': 'application/json',
					},
					body: JSON.stringify(
						{
							nonce: gforms_ppcp_frontend_strings.create_subscription_nonce,
							form_data: $( self.form ).serialize(),
							form_id: self.formId,
							feed_id: self.activeFeed.feedId,
						}
					),
				}
			).then(
				function( res ) {
					return res.json();
				}
			).then(
				function( response ) {
					if ( response.success ) {
						subscriptionRequest = response.data;
						self.resetCardErrors();
					} else {
						self.displayCardError( response.data.message );
						self.resetPayPalStatus();
						return false;
					}
				}
			);

			subscriptionRequest.application_context.user_action = 'CONTINUE';
			return actions.subscription.create( subscriptionRequest );
		};

		/**
		 * Fires when user approves a subscription created using smart buttons.
		 *
		 * @since 2.0
		 *
		 * @param {Object} data
		 * @param {Object} actions
		 */
		self.onSubscriptionApprove = function( data, actions ) {
			// Appeand created subscription ID to form.
			if ( self.subscriptionIdField.length === 0 ) {
				$( self.form ).append( $( '<input type="hidden" id="gf_' + self.formId + '_ppcp_subscription_id" name="ppcp_subscription_id" />' ).val( data.subscriptionID ) );
			}

			$( self.form ).submit();
		};

		/**
		 * Fires when an error ocures while creating a subscription using smart buttons.
		 *
		 * @since 2.0
		 */
		self.onSubscriptionError = function() {
			self.displayCardError( gforms_ppcp_frontend_strings.catch_all_error );
		};

		/**
		 * Fires when the user cancels creating a subscription using smart buttons.
		 *
		 * @since 2.0
		 */
		self.onSubscriptionCancel = function() {
			self.resetCardErrors();
			self.hideFormSpinner();
		};

		self.renderCustomCardFields = function() {
			if ( ! self.canShowCustomCardFields() ) {
				$( '.ginput_container_custom_card_fields' ).hide();
				return;
			}

			if ( ! $( self.form ).data( 'gfppcpcustomcardrendered' ) && ! self.requestingCards ) {
				const placeholder_1 = $( '#input_' + self.formId + '_' + self.ccFieldId + '_1' ).text();
				const placeholder_2 = $( '#input_' + self.formId + '_' + self.ccFieldId + '_2' ).text();
				const placeholder_3 = $( '#input_' + self.formId + '_' + self.ccFieldId + '_3' ).text();

				// Clear the placeholder in <span>.
				$( '#input_' + self.formId + '_' + self.ccFieldId + '_1, #input_' + self.formId + '_' + self.ccFieldId + '_2, #input_' + self.formId + '_' + self.ccFieldId + '_3' ).text( '' );

				paypal.HostedFields.render(
					{
						createOrder: self.createOrder,
						styles: self.cardStyle,
						fields: {
							number: {
								selector: '#input_' + self.formId + '_' + self.ccFieldId + '_1',
								placeholder: placeholder_1
							},
							cvv: {
								selector: '#input_' + self.formId + '_' + self.ccFieldId + '_3',
								placeholder: placeholder_3
							},
							expirationDate: {
								selector: '#input_' + self.formId + '_' + self.ccFieldId + '_2',
								placeholder: placeholder_2
							}
						}
					}
				).then(
					function ( hf ) {
						$( self.form ).attr( 'data-gfppcpcustomcardrendered', true );
						self.requestingCards = false;

						hf.on(
							'focus',
							function( event ) {
								if ( event.emittedBy === 'number' ) {
									wp.a11y.speak(
										$( '#field_' + self.formId + '_' + self.ccFieldId + '_supported_creditcards' ).text()
									);
								}
							}
						);

						hf.on(
							'cardTypeChange',
							function (event) {
								let cardType;
								const cardContainer = $( '#input_' + self.formId + '_' + self.ccFieldId + '_1' ).parents( '.gfield' ).find( '.gform_card_icon_container' );

								if ( event.cards.length !== 1 ) {
									cardType = null;
								} else {
									cardType = event.cards[0].niceType.toLowerCase();

									if ( cardType === 'american express' ) {
										cardType = 'amex';
									}
								}

								if ( ! cardType ) {
									$( cardContainer ).find( '.gform_card_icon' ).removeClass( 'gform_card_icon_selected gform_card_icon_inactive' );
								} else {
									// Display the check on card icons.
									$( cardContainer ).find( '.gform_card_icon' ).removeClass( 'gform_card_icon_selected' ).addClass( 'gform_card_icon_inactive' );
									$( cardContainer ).find( '.gform_card_icon_' + cardType ).removeClass( 'gform_card_icon_inactive' ).addClass( 'gform_card_icon_selected' );
									// Check if the credit card is supported.
									event.cards[0].type = cardType;
									self.isCardSupported( event.cards[0] );
								}

								if ( $( '#ppcp_credit_card_type' ).length ) {
									$( '#ppcp_credit_card_type' ).val( event.cards[0].niceType );
								} else {
									$( self.form ).append( $( '<input type="hidden" name="ppcp_credit_card_type" id="ppcp_credit_card_type" />' ).val( event.cards[0].niceType ) );
								}
							}
						);

					$(self.form).on('submit', function (event) {
						if (
							! self.feedActivated ||
							self.paymentMethod!=='Credit Card' ||
							$( '#gform_save_' + self.formId ).val()==='1' ||
							$( this ).data( 'gfppcpsubmitting' ) ||
							window[ self.totalName ] <= 0 ||
							! self.isCreditCardOnPage() ||
							self.isGoPrevPage() ||
							'undefined' !== typeof gformIsRecaptchaPending && gformIsRecaptchaPending( $( self.form ) )
						) {
							return true;
						}

								gformAddSpinner( self.formId );
								event.preventDefault();

								if ( ! $( self.form ).data( 'gfppcpsubmitting' ) ) {
									$( self.form ).data( 'gfppcpsubmitting', true );
								}

								// Validate CC fields.
								let state     = hf.getState();
								let formValid = Object.keys( state.fields ).every(
									function ( key ) {
										return state.fields[ key ].isValid;
									}
								);

								if ( ! formValid ) {
									// Let the customer know their fields are invalid.
									self.displayCardError( gforms_ppcp_frontend_strings.card_info_error );
									self.resetPayPalStatus();

									return false;
								} else {
									self.resetCardErrors();
								}

								// CC fields are valid, submit hosted fields card data to PayPal.
								let cardData = {
									contingencies: ['3D_SECURE']
								};

								// Card holder name is not hidden.
								if ( $( '#input_' + self.formId + '_' + self.ccFieldId + '_5' ).length) {
									cardData.cardholderName = $( '#input_' + self.formId + '_' + self.ccFieldId + '_5' ).val();
								}

								hf.submit( cardData ).then(
									function ( payload ) {
										// Needed only when 3-D Secure contingency applied
										if ( payload.liabilityShifted === undefined ) {
											// Handle no 3-D Secure contingency passed scenario
											$( self.form ).submit();
										} else if ( payload.liabilityShifted ) {
											// Handle Buyer confirmed 3-D Secure successfully
											$( self.form ).submit();
										} else {
											if ( payload.authenticationReason === 'SKIPPED_BY_BUYER' ) {
												// Handle buyer skipped 3-D Secure use-case
												const result = confirm( gforms_ppcp_frontend_strings.skipped_by_buyer );
												if ( result ) {
													$( self.form ).submit();
												}
											} else {
												self.displayCardError( gforms_ppcp_frontend_strings.threed_secure_error );
												self.resetPayPalStatus();
											}
										}
									}
								).catch(
									function ( error ) {
										self.resetPayPalStatus();
										// Supported card types cannot be detected by the validityChange event,
										// but only after submitting the fields, an error would be thrown.
										if ( error.hasOwnProperty( 'details' ) ) {
											self.displayCardError( error.details[0].description );
										}
									}
								);
							}
						);
					}
				);

				self.requestingCards = true;
			}

			// Display Custom Card Fields.
			$( '.ginput_container_custom_card_fields' ).show();
			// Show the submit button.
			self.toggleSubmitButton( 'visible' );
			// Hide PayPal Smart buttons.
			self.paypalButtons.hide();
		};

		self.getCountryCode = function ( country ) {
			return $.ajax(
				{
					async: false,
					url: gforms_ppcp_frontend_strings.ajaxurl,
					dataType: 'json',
					method: 'POST',
					data: {
						action: "gfppcp_get_country_code",
						nonce: gforms_ppcp_frontend_strings.on_approve_nonce,
						country: country,
						feed_id: self.activeFeed.feedId
					},
					success: function ( response ) {
						if ( response.success ) {
							self.countryCode = response.data.code;
						}
					}
				}
			);
		};

		self.displayPaymentMethod = function ( paymentMethod ) {
			if ( ! self.feedActivated ) {
				$( '.gform_ppcp_custom_card_fields' ).hide();
				self.paymentMethod = '';
			} else {
				// Hide the PayPal field if only PayPal Checkout supported.
				if ( Object.keys( self.paymentMethods ).length === 1 && paymentMethod === 'PayPal Checkout' ) {
					$( '.gform_ppcp_custom_card_fields' ).hide();
				} else {
					$( '.gform_ppcp_custom_card_fields' ).show();
				}

				if ( typeof paymentMethod === 'string' ) {
					self.paymentMethod = paymentMethod;
				} else {
					// This is triggered by payment selection change.
					if ( paymentMethod.hasOwnProperty( 'target' ) ) {
						self.removeIdFields();
						paymentMethod = $( paymentMethod.target );
					}

					self.paymentMethod = paymentMethod.val();

					// Clear errors in the credit card field.
					self.resetCardErrors();
				}
			}

			self.renderPayPalField();
		};

		self.renderPaymentMethod = function () {

			const paymentMethodField = $( '.gform_ppcp_payment_method select' );
			const paymentMethod      = Object.keys( self.paymentMethods ).length > 1 ? paymentMethodField.val() : self.paymentMethods[0];
			self.displayPaymentMethod( paymentMethod );

			paymentMethodField.on( 'change', self.displayPaymentMethod );
		};

		self.toggleSubmitButton = function ( status ) {
			const submitButton = $( '#gform_submit_button_' + self.formId );
			submitButton.css( 'visibility', status );
			if ( status === 'hidden' ) {
				submitButton.css( 'position', 'absolute' );
				submitButton.css( 'left', '-9999em' );
			} else {
				submitButton.css( 'position', 'static' );
				submitButton.css( 'left', '0' );
			}
		};

		self.togglePaypalButtons = function ( status ) {
			$( self.paypalButtons ).css( 'display', status );
		};

		self.isCreditCardOnPage = function () {
			const currentPage = self.getCurrentPageNumber();

			// if current page is false or no credit card page number, assume this is not a multi-page form.
			if ( ! self.ccPage || ! currentPage ) {
				return true;
			}

			return self.ccPage === currentPage;
		};

		self.getCurrentPageNumber = function () {
			const currentPageInput = $( '#gform_source_page_number_' + self.formId );

			return currentPageInput.length > 0 ? parseInt( currentPageInput.val(), 10 ) : false;
		};

		self.isLastPage = function () {
			const targetPageInput = $( '#gform_target_page_number_' + self.formId );
			if ( targetPageInput.length > 0 ) {
				return targetPageInput.val() === '0';
			}

			return true;
		};

		self.isCardSupported = function ( card ) {
			if ( $.inArray( card.type, Object.keys( window['gf_cc_rules'] ) ) === -1 ) {
				self.displayCardError( card.niceType + ' ' + gforms_ppcp_frontend_strings.card_not_supported );
			} else {
				self.resetCardErrors();
			}
		};

		self.displayCardError = function ( message ) {
			if ( typeof message === 'undefined' ) {
				message = '';
			}

			let messageContainer = self.getMessageContainerSelector();

			if ( ! $( messageContainer ).find( '.validation_message' ).length ) {
				$( messageContainer ).append( '<div class="gfield_description validation_message"></div>' );
			}

			var cardErrors = self.getCardErrors();

			if ( message !== '' ) {
				$( messageContainer ).addClass( 'gfield_error' );
				$( cardErrors[ 0 ] ).html( message ).show();
				// Announce the error to the screen reader.
				wp.a11y.speak( message, 'assertive' );
				self.hideFormSpinner();
			}
		};

		/**
		 * Resets field error state and removes any displayed errors.
		 *
		 * @since 2.0
		 */
		self.resetCardErrors = function() {
			const messageContainer = self.getMessageContainerSelector();
			const cardErrors = self.getCardErrors();
			$( messageContainer ).removeClass( 'gfield_error' );
			$( cardErrors[ 0 ] ).html( '' );
		}

		/**
		 * Gets the selector of the container div in which an error message will be displayed.
		 *
		 * @since 2.0
		 *
		 * return {string}
		 */
		self.getMessageContainerSelector = function() {
			var messageContainer = self.GFCCField;
			// If field is hidden when checkout is the only available option, use button container as message container.
			if ( $( messageContainer ).is( ':hidden' ) ) {
				messageContainer = '#gform_ppcp_smart_payment_buttons';
			}

			return messageContainer;
		}

		/**
		 * Gets a list of error elements within the card message container.
		 *
		 * @since 2.0
		 *
		 * @return {jQuery} an array of elements that contain error messages.
		 */
		self.getCardErrors = function() {
			var messageContainer = self.getMessageContainerSelector();
			return $( messageContainer ).find( '.validation_message' );
		}

		/**
		 * Hides the form spinner that appears next to submit button.
		 *
		 * @since 2.0
		 */
		self.hideFormSpinner = function() {
			if ( $( '#gform_ajax_spinner_' + self.formId ).length > 0 ) {
				$( '#gform_ajax_spinner_' + self.formId ).remove();
			}
		}

		self.resetPayPalStatus = function () {
			$( self.form ).data( 'gfppcpsubmitting', false );
			$( '#gform_ajax_spinner_' + self.formId ).remove();

			// must do this or the form cannot be submitted again
			if ( self.isLastPage() ) {
				window[ 'gf_submitting_' + self.formId ] = false;
			}
		};

		self.isGoPrevPage = function () {
			// don't create card token if clicking on the Previous button.
			const sourcePage = parseInt( $( '#gform_source_page_number_' + self.formId ).val(), 10 );
			const targetPage = parseInt( $( '#gform_target_page_number_' + self.formId ).val(), 10 );

			return sourcePage > targetPage && targetPage !== 0;
		};

		/**
		 * Removes PayPal order ID and subscription ID fields when order details change.
		 *
		 * @since 2.0
		 */
		self.removeIdFields = function() {
			self.orderIdField.remove();
			self.subscriptionIdField.remove();
		};

		self.init();
	}

})( jQuery );
